import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

import { ButtonLoader } from "components/__new/common/form";
import FormDrawer from "components/__new/common/form-drawer";
import * as transfersAction from 'store/entities/transfers/action';

export const DeleteTransferBeneficiaryModal = (props) => {
    const { isOpen, setIsOpen, beneficiaryId, getTransferBeneficiaries } = props;
    const dispatch = useDispatch();
    const { deleteTransferBeneficiaryLoading, deleteTransferBeneficiary } = useSelector(s => s.entities.transfers);
    
    const handleDeleteBeneficiary = () => {
        dispatch(transfersAction.deleteTransferBeneficiary(beneficiaryId))
    }
    
    useEffect(() => {
        if (deleteTransferBeneficiary?.status === "success") {
            toast.success("Beneficiary successfully deleted");
            setIsOpen(false);
            getTransferBeneficiaries();
            dispatch(transfersAction.resetDeleteTransferBeneficiary());
        }
    }, [deleteTransferBeneficiary]);
    
    return (
        <FormDrawer display="center" size="md" isOpen={isOpen} setIsOpen={setIsOpen}>
            <div className="p-6">
                <FormDrawer.Title
                    title="Delete This Beneficiary"
                    showCloseButton={true}
                    close={setIsOpen}
                />

                <div className="mt-8">
                    <div className="flex items-center text-[#4A5564] font-normal">
                        Are you sure you want to perform this action?
                    </div>
                </div>

                <div className="p-1 mt-8 flex items-center space-x-3">
                    <ButtonLoader onClick={handleDeleteBeneficiary} loading={deleteTransferBeneficiaryLoading} type="button" className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-[#DC2626] text-white bg-[#DC2626]">
                        Yes
                    </ButtonLoader>

                    <button type="button" className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-ep-primary-600 bg-white"
                        onClick={() => setIsOpen(false)}
                    >
                        No
                    </button>
                </div>
            </div>
        </FormDrawer>
    )
}